import { render, staticRenderFns } from "./TimelineConsentCard.vue?vue&type=template&id=204bc99c&scoped=true&"
import script from "./TimelineConsentCard.vue?vue&type=script&lang=js&"
export * from "./TimelineConsentCard.vue?vue&type=script&lang=js&"
import style0 from "./TimelineConsentCard.vue?vue&type=style&index=0&id=204bc99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204bc99c",
  null
  
)

export default component.exports